export default __webpack_public_path__ + "static/actions-fab-swipe-toolbar-b26da1807b544c3d53819260c52e25c3.gif";